import {
	checkInputOnLength,
	checkEmailConfirmation,
	checkEmailExists,
	checkLoginExists,
	checkPasswordRequirements,
	showPasswordRules,
	checkPasswordConfirmation,
	checkSsnExists,
	handleTypeChange
} from "./utils";
import { checkCEP, setToNoNumber, handleStateChange, onChangeCity } from "./address";
import { checkValidityError } from "../shared/validation-utils";

export const baseFields = {
	type_person: {
		onClick: handleTypeChange
	},
	type_company: {
		onClick: handleTypeChange
	}
};

export const companyFields = {
	company_name: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	fancy_name: { required: true },
	contact_name: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	cnpj: {
		required: true,
		"aria-required": true,
		onInvalid: checkValidityError,
		onChange: checkInputOnLength,
		onBlur: checkSsnExists
	},
	inscricao_municipal: {
		required: false,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	iss: {
		required: false,
		"aria-required": false
	}
};

export const personFields = {
	register_name: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError,
		onBlur: checkInputOnLength
	},
	cpf: {
		required: true,
		"aria-required": true,
		onInvalid: checkValidityError,
		onChange: checkInputOnLength,
		onBlur: checkSsnExists
	},
	register_birth: {
		required: true,
		"aria-required": true,
		onInvalid: checkValidityError,
		onChange: checkInputOnLength,
		onBlur: checkInputOnLength
	},
	register_gender: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	}
};

export const addressFields = {
	register_cep: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError,
		onBlur: checkCEP
	},
	address_country: {
		required: false,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	address_city: {
		required: true,
		"aria-required": true,
		onChange: onChangeCity,
		onInvalid: checkValidityError
	},
	register_address: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	address_number: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	no_number: {
		required: false,
		onChange: setToNoNumber
	},
	address_complement: { required: false },
	register_neighborhood: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	address_state: {
		required: true,
		"aria-required": true,
		onChange: handleStateChange,
		onInvalid: checkValidityError
	}
};

export const contactFields = {
	carrier1: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	phone1: {
		required: true,
		"aria-required": true,
		onBlur: checkValidityError,
		onInvalid: checkValidityError,
		onChange: checkInputOnLength
	},
	carrier2: { required: false }, //TODO validar se um dos dois campos de tel secundario esta preenchido, em caso positivo o outro é obrigatorio
	phone2: { required: false }
};

export const accessFields = {
	email: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError,
		onBlur: checkEmailExists
	},
	confirmEmail: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError,
		onBlur: checkEmailConfirmation
	},
	password: {
		required: true,
		"aria-required": true,
		onKeyup: checkPasswordRequirements,
		onChange: checkPasswordRequirements,
		onInvalid: checkValidityError,
		onClick: () => showPasswordRules(true),
		onFocus: () => showPasswordRules(true),
		onBlur: () => showPasswordRules(false)
	},
	confirmPassword: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError,
		onBlur: checkPasswordConfirmation
	},
	register_quest: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	},
	terms: {
		required: true,
		"aria-required": true,
		onChange: checkValidityError,
		onInvalid: checkValidityError
	}
};

export const fieldMapper = {
	companyName: "company_name",
	fancyName: "fancy_name",
	contactName: "contact_name",
	cnpj: "cnpj",
	inscricaoMunicipal: "inscricao_municipal",
	name: "register_name",
	cpf: "cpf",
	birthday: "register_birth",
	gender: "register_gender",
	addressZipCode: "register_cep",
	address_country: "address_country",
	addressCity: "address_city",
	address: "register_address",
	addressNumber: "address_number",
	no_number: "no_number",
	addressComplement: "address_complement",
	addressNeighborhood: "register_neighborhood",
	addressState: "address_state",
	carrier1: "carrier1",
	phone1: "phone1",
	carrier2: "carrier2",
	phone2: "phone2",
	email: "email",
	confirmEmail: "confirmEmail",
	password: "password",
	confirmPassword: "confirmPassword",
	optionId: "register_quest",
	terms: "terms",
	iss: "iss"
};
